import React, { useEffect, useState } from "react";
import { getAllProfileAssets, updateImageStatus } from "utils/enduserUtils";
import { ProfileAsset, AssetStatus } from "models/profile/Profile";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { TableColumnProps, TablePage } from "components/alove/TablePage";
import { avatarUrl, camelCaseToCapitalizedWords, formatDateTime } from "utils/globalsUtils";
import { ImageDialog } from "components/alove/ImageDialog";
import { Grid, Tooltip, Typography } from "@mui/material";
import { InfoOutlined } from "@mui/icons-material";
import { GridColDef } from "@mui/x-data-grid-pro";
import { addAlert, useMaterialUIController } from "context";
import { EnumAutocomplete } from "components/alove/EnumAutocomplete";
import { Link } from "react-router-dom";

function ProfileAssetsList() {
  const [controller, dispatch] = useMaterialUIController();

  const valueString = (value: any, key?: string) => {
    let _value = value
 
    if (typeof value === "boolean") {
      _value = value ? "Yes":"No"
    }
    if (typeof value === "number") {
      if (0 <= value && value <= 1) {
        _value = (value * 100) + "%";
      }
    }
    if (key === "faceCount") {
      _value = value
    }
    if (_value?.length > 10) {
      return <Tooltip title={_value}>{_value}</Tooltip>
    }
    return ` ${_value}`;
  }


  const columns: GridColDef<ProfileAsset>[] = [
    {
        headerName: "Image",
        field: "uri",
        width: 150,
        renderCell: (params) => {
            return <Grid container style={{height: "100%", lineHeight: "15px"}} justifyContent="space-evenly" alignItems="center">
            <ImageDialog url={avatarUrl(params.row.profileId, params.row.uri)} size="100px"/>
            <EnumAutocomplete
              value={params.row.assetStatusId}
              onChange={(value) => {
                updateImageStatus(params.row.profileId, params.row.asset_id, value)
                  .then(() => addAlert(dispatch, "Image status updated"))
              }}
              enumName={AssetStatus}
            />
            <Typography variant="body2">{formatDateTime(params.row.created)}</Typography>
            <Link to={`/endusers/${params.row.profileId}`} target="_blank">
              <Typography variant="body2">View Profile</Typography>
            </Link>
            </Grid>
        }
    },
    {
        headerName: "Verdict",
        field: "verdict",
        renderCell: (params) => (
          <Grid container spacing={1} flexDirection="column" flexWrap="wrap" style={{height: "100%", lineHeight: "15px"}} justifyContent="center">
          <Grid><b>{params.row.moderationResult?.verdict}</b></Grid>
          <Grid><b>Quality:</b>   {valueString(params.row.moderationResult?.qualityAssessment?.score)}</Grid>
          {params.row.moderationResult?.qualityAssessment?.note && <Grid><b>Note:</b> <Tooltip title={params.row.moderationResult?.qualityAssessment?.note}><InfoOutlined /></Tooltip></Grid>}
          </Grid>
        )
    },
    {
        headerName: "Moderation Results",
        field: "moderationResult",
        flex: 1,
        renderCell: (params) => {
          const moderationResults = params.row.moderationResult?.moderationResults || {};
            return (
              <Grid container spacing={1} flexDirection="column" flexWrap="wrap" style={{height: "100%", lineHeight: "15px"}} justifyContent="space-evenly">
                          {Object.keys(moderationResults).map((key) => {

                  return (
                    <Grid><b>{camelCaseToCapitalizedWords(key)}:</b>   {valueString(moderationResults[key]?.present)}
                      {moderationResults[key]?.confidence ? ` (${valueString(moderationResults[key].confidence)}) ` : ""}
                      {moderationResults[key]?.note ? <Tooltip title={moderationResults[key]?.note}><InfoOutlined /></Tooltip> : ""}
                    </Grid>
                  );
              })}
              {Object.keys(params.row.moderationResult?.faceDetections || {}).map((key) => {
                return <Grid><b>{camelCaseToCapitalizedWords(key)}:</b> 
                  {valueString(params.row.moderationResult?.faceDetections[key], key)}</Grid>;
              })}
              </Grid>
            );
        }
    },
    {
        headerName: "Person Features",
        field: "personFeatures",
        flex: 2,
        renderCell: (params) => (
          <Grid container spacing={1} flexDirection="row" flexWrap="wrap" style={{height: "100%", lineHeight: "15px"}} alignItems="center">
            {Object.keys(params.row.moderationResult?.personFeatures || {}).map((key) => {
              return <Grid size={4} style={{textOverflow: "ellipsis", overflow: "hidden", whiteSpace: "nowrap"}}>
                <b>{camelCaseToCapitalizedWords(key)}:</b>
                   {valueString(params.row.moderationResult?.personFeatures[key], key)}</Grid>;
            })}
          </Grid>
        )}
  ];

  const processRowUpdate = (newRow: ProfileAsset, oldRow: ProfileAsset) => {
    ;
    ;
    updateImageStatus(newRow.profileId,newRow.asset_id, newRow.assetStatusId)
      .then(() => addAlert(dispatch, "Image status updated"))
    return newRow;
  }

  const getPendingAssets = ( filters, page) => {
    return getAllProfileAssets(filters.pending, page)
  }

  return (
    <DashboardLayout>
        <DashboardNavbar/>
        <TablePage
          title="Profile Images"
          table={{
            columns,
            loadNext: getPendingAssets,
            getRowId: (row) => row.asset_id,
            getRowHeight: (row) => 300,
            processRowUpdate,
          }}
          filters={[{
            label: "pending",
            type: "switch"
          }]}
        />
    </DashboardLayout>
  );
}

export default ProfileAssetsList; 